import { FC } from 'react'
import styled from 'styled-components'
import { ActivityTypeID } from 'constants/enums'
import { ACTIVITY_TYPE_TEXT } from 'constants/typeText'

interface IFActivityListScreenHeaderDesktopProps {
  activityType: ActivityTypeID
  className?: string
}

const ActivityListScreenHeaderDesktop: FC<
  IFActivityListScreenHeaderDesktopProps
> = ({ activityType, className }) => {
  return (
    <StyledWrapper className={className}>
      <h1 className="typo">{ACTIVITY_TYPE_TEXT[activityType]}</h1>
    </StyledWrapper>
  )
}

export default ActivityListScreenHeaderDesktop

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 56px 0px 24px;

  .typo {
    font-weight: bold;
    cursor: default;
    font-size: 26px;
  }
`
